module.exports = __webpack_public_path__ + "img/pheopara.6317f8e3.png";